import { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import Rating from './Rating';

const OneTimeLink = () => {
  const { id, ratingId } = useParams();
  const [canAccess, setCanAccess] = useState(false);
  const [loading, setLoading] = useState(true);
  const server_url = process.env.REACT_APP_API_URI;

  useEffect(() => {
    const checkAccess = async () => {
      try {
        if (!ratingId) {
          // If no ratingId is provided, it's a direct or verified link. Allow access.
          setCanAccess(true);
          setLoading(false);
          return;
        }

        const response = await fetch(
          `${server_url}/businessRating/rating/checkRatingId`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              businessId: id,
              ratingId: ratingId,
            }),
          },
        );

        const data = await response.json();

        if (data.exists === false) {
          setCanAccess(true);
        } else {
          setCanAccess(false);
        }
      } catch (error) {
        console.error('Error checking rating access:', error);
        setCanAccess(false);
      } finally {
        setLoading(false);
      }
    };

    checkAccess();
  }, [id, ratingId]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="text-lg text-gray-700">Loading...</div>
      </div>
    );
  }

  return canAccess ? (
    <Rating />
  ) : (
    <div className="flex flex-col items-center justify-center min-h-[60vh] bg-primary px-4">
      <div className="bg-white/10 p-8 rounded-xl shadow-lg max-w-md text-center">
        <h2 className="text-3xl font-semibold text-secondary mb-4">
          Thank You!
        </h2>
        <p className="text-white mb-6">
          You have already submitted your rating. <br />
          We truly appreciate your feedback!
        </p>
        <button
          onClick={() => (window.location.href = '/')}
          className="bg-secondary text-primary px-6 py-2 rounded-xl transition duration-200"
        >
          Go to Home
        </button>
      </div>
    </div>
  );
};

export default OneTimeLink;
